import * as React from 'react';
import { stripHTMLTagsFromString, toInnerHTML } from '../../../../utils/string';

interface IOwnProps {
  text: string;
  length: number;
  tail?: string;
  tailClassName?: string;
}

export default class EllipsisLabel extends React.Component<IOwnProps, {}> {
  static defaultProps: Partial<IOwnProps> = {
    tail: '...',
    tailClassName: 'more',
  };

  createLabelMarkup(text: string = this.props.text) {
    return toInnerHTML(text);
  }

  render() {
    const {
      length,
      tail,
      tailClassName,
      text,
      ...props
    } = this.props;

    const textWithoutHTML = stripHTMLTagsFromString(text);

    if (textWithoutHTML.length <= length || length < 0) {
      return <span dangerouslySetInnerHTML={this.createLabelMarkup()} {...props} />;
    }

    const displayText = length - tail!.length <= 0
      ? text
      : text.slice(0, length);

    return (
      <span title={text} {...props}>
        <span dangerouslySetInnerHTML={this.createLabelMarkup(displayText)} />
        <span className={tailClassName}>{tail}</span>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/text/EllipsisLabel/index.tsx